import { Builder } from '@builder.io/react';

import Table from './index';

Builder.registerComponent(Table, {
  name: 'Table',
  inputs: [
    {
      name: 'columns',
      type: 'list',
      subFields: [
        {
          name: 'name',
          type: 'string',
          defaultValue: 'firstHead'
        }
      ]
    },
    {
      name: 'rows',
      type: 'list',
      subFields: [
        {
          name: 'items',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              defaultValue: 'fistChild'
            }
          ]
        }
      ]
    }
  ]
});
